import { useEffect, useState } from 'react'

import { Flex } from '../../../../Components'
import { cap } from '../../../../State'
import { isFieldNotRequired } from '../Functions'
import { AirportInput } from './AirportInput'
import { useTransferField } from './Hook'
import { FloatInput } from './InputForm'
import { StationInput } from './StationInput'
const language = cap.language.state || 'it'

export const TransferField = (props) => {
  const { item: { type = '' } = {} } = props || {}
  if (type === 'airport') {
    return <AirportInput {...props} />
  }
  if (type === 'station') return <StationInput {...props} />
  return <StandardInput {...props} />
}

const StandardInput = ({ state: [state, setState], item, count, readOnly, diffStatus }) => {
  const { location, type, label, id, options, minDate, fullLine = false, limitLength } = item
  // Facoltativo per il campo stesso o per il profilo del flusso (Goelett: solo ciò che serve alla ricerca)
  const notRequired = isFieldNotRequired(state, item)
  const [data = '', setData] = useTransferField([state, setState], location, count, !notRequired)
  const [error, setError] = useState(false)

  useEffect(() => {
    setError(!data && !notRequired)
  }, [data, notRequired])

  return (
    <Flex key={item.id} as js style={{ width: fullLine ? '100%' : '23%', margin: '5px 1%' }}>
      <FloatInput
        value={[data, setData]}
        id={count + id}
        label={label?.[language.toLowerCase() || 'it']}
        type={type}
        options={options}
        error={error}
        readOnly={readOnly}
        minDate={minDate}
        diffStatus={diffStatus}
        limitLength={limitLength}
      />
    </Flex>
  )
}
